var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4577 7.43809L13.4577 10.9237C13.4577 11.871 12.6862 12.6396 11.7418 12.6396L3.34103 12.6396C2.39374 12.6396 1.62514 11.8682 1.62514 10.9237L1.62514 7.38136C1.62514 7.16865 1.45497 6.99848 1.24226 6.99848C1.02955 6.99848 0.859375 7.16865 0.859375 7.38136L0.859375 10.9237C0.859375 12.2936 1.97399 13.4054 3.34103 13.4054L11.7418 13.4054C13.1116 13.4054 14.2234 12.2908 14.2234 10.9237L14.2234 7.43809C14.2234 7.22537 14.0533 7.0552 13.8405 7.0552C13.6278 7.0552 13.4577 7.22821 13.4577 7.43809Z",
    fill: "#4C1E8D",
    stroke: "#4C1E8D",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81711 10.3636L10.2505 7.93019C10.4009 7.77987 10.4009 7.53879 10.2505 7.38848C10.1002 7.23816 9.85915 7.23816 9.70883 7.38848L7.92772 9.16959L7.92772 1.40132C7.92772 1.1886 7.75755 1.01843 7.54483 1.01843C7.33212 1.01843 7.16195 1.1886 7.16195 1.40132L7.16195 9.16959L5.38083 7.38848C5.23052 7.23816 4.98944 7.23816 4.83912 7.38848C4.76538 7.46222 4.72568 7.56148 4.72568 7.65791C4.72568 7.75434 4.76255 7.85361 4.83912 7.92735L7.27256 10.3608C7.42571 10.5139 7.66963 10.5139 7.81711 10.3636Z",
    fill: "#4C1E8D",
    stroke: "#4C1E8D",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPurple);
export default __webpack_public_path__ + "static/media/download-purple.164a032e53ca0d1e0282135e1117e67b.svg";
export { ForwardRef as ReactComponent };